import QnAdCard from "@elements/Card/QuickNews/QnAdCard";
import { QnEndCard } from "@elements/Card/QuickNews/QnEndCard";
import { QnQuizCard } from "@elements/Card/QuickNews/QnQuizCard";
import QnVideoCard from "@elements/Card/QuickNews/QnVideoCard";
import { QuickNewsCard } from "@elements/Card/QuickNews/QuickNewsCard";
import { FeedItem, QNCardType, VideoItem } from "@typings/QuickNews";

type FeedRenderProps = {
  card: FeedItem;
  index: number;
  isMobile: boolean;
  articleIndex: number;
  switchTab: (tab: QNCardType, eventType?: string) => void;
  prevCard: () => void;
  nextCard: () => void;
  getOlderArticles: () => void;
  enableVideos?: boolean;
  isMute: boolean;
  setIsMute: (mute: boolean) => void;
};

type VideoRenderProps = {
  card: VideoItem;
  index: number;
  isMute: boolean;
  setIsMute: (mute: boolean) => void;
  activeTab: string;
  videoIndex: number;
};

export const renderFeedCard = ({
  card,
  index,
  isMobile,
  articleIndex,
  switchTab,
  prevCard,
  nextCard,
  getOlderArticles,
  enableVideos = false,
  isMute,
  setIsMute,
}: FeedRenderProps) => {
  if (enableVideos && "myFeedVideoIndex" in card) {
    return (
      <QnVideoCard
        key={card.id}
        bcVideo={card}
        isMute={isMute}
        setIsMute={setIsMute}
        isActive={articleIndex === card.myFeedVideoIndex}
      />
    );
  }
  if ("quizzes" in card) return <QnQuizCard key={card.id} item={card} />;
  if ("adType" in card)
    return (
      <QnAdCard
        key={card.id}
        item={card}
        onNext={nextCard}
        isMobile={isMobile}
      />
    );

  if ("endCard" in card)
    return (
      <QnEndCard
        key={card.id}
        item={card}
        feedType="MyFeed"
        getOlderArticles={getOlderArticles}
      />
    );
  if ("title" in card) {
    return (
      <QuickNewsCard
        key={card.id}
        item={card}
        index={index}
        typeIndex={articleIndex}
        setActiveTab={switchTab}
        onPrev={prevCard}
        onNext={nextCard}
      />
    );
  }
};

export const renderVideoCard = ({
  card,
  index,
  isMute,
  setIsMute,
  activeTab,
  videoIndex,
}: VideoRenderProps) => {
  if ("endCard" in card)
    return <QnEndCard key={card.id} item={card} feedType="Videos" />;
  return (
    <QnVideoCard
      key={card.id}
      bcVideo={card}
      isMute={isMute}
      setIsMute={setIsMute}
      isActive={activeTab === "Videos" && index === videoIndex}
    />
  );
};
